var btnOpenContact = document.getElementById('btnOpenContact')
		var btnCloseContact = document.getElementById('btnCloseContact')
		var btnLocate = document.getElementById('btnLocate')
		var btnEmail = document.getElementById('btnEmail')
		
		var contactPopup = document.getElementById('contactPopup')
		var boxLocate = document.getElementById('boxLocate')
		var boxemail = document.getElementById('boxemail')

		if(btnOpenContact){
			btnOpenContact.addEventListener('click',function(){
				if(contactPopup){
					contactPopup.classList.add('active')
				}
			}) 
		}
		if(btnCloseContact){
			btnCloseContact.addEventListener('click',function(){
				if(contactPopup){
					contactPopup.classList.remove('active')
				}
			})
		}
		if(btnLocate){
			btnLocate.addEventListener('click',function(){
				this.classList.add('active')
				if(btnEmail){
					btnEmail.classList.remove('active')
				}
				if(boxLocate){
					boxLocate.classList.add('active')
				}
				if(boxemail){
					boxemail.classList.remove('active')
				}
			})
		}
		if(btnEmail){
			btnEmail.addEventListener('click',function(){
				this.classList.add('active')
				if(btnLocate){
					btnLocate.classList.remove('active')
				}
				if(boxLocate){
					boxLocate.classList.remove('active')
				}
				if(boxemail){
					boxemail.classList.add('active')
				}
			})
		}